import { Component, type ErrorInfo, type ReactNode } from 'react';
import ErrorScreen from '@/components/ErrorScreen';

interface ErrorBoundaryProps {
  readonly children: ReactNode;
  /** Где стоит ограничитель: на корне приложения (без шапки) или вокруг страницы кабинета. */
  readonly place?: 'root' | 'cabinet';
}

interface ErrorBoundaryState {
  readonly hasError: boolean;
}

// Class component is the sanctioned exception for error boundaries (React has no hook equivalent).
export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // eslint-disable-next-line no-console -- root-level diagnostics; no user-facing logging here
    console.error('Uncaught error:', error, errorInfo);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return <ErrorScreen place={this.props.place} />;
    }
    return this.props.children;
  }
}
